var _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgPremiumSubscr = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 76,
  height: 76,
  viewBox: "0 0 76 76",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 76,
  height: 76
}, /*#__PURE__*/React.createElement("rect", {
  width: 76,
  height: 76,
  rx: 6,
  fill: "#E4E8EC",
  fillOpacity: 0.5
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("rect", {
  x: -1.70789,
  y: 42.6967,
  width: 36.7191,
  height: 35.0112,
  rx: 6,
  fill: "#336CA0"
}), /*#__PURE__*/React.createElement("rect", {
  x: 38.427,
  y: -2.56177,
  width: 36.7191,
  height: 35.0112,
  rx: 6,
  fill: "#336CA0"
}))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPremiumSubscr, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/premiumSubscr.8074f403.svg";
export { ForwardRef as ReactComponent };